import { useState , useCallback, useEffect, useRef } from "react";
import { debounce } from "lodash";

import {
  IconButton,
  Box,
  Typography,
  CardContent,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import MuiStep from "@mui/material/Step";
import CustomChip from "../../../components/mui/chip";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { DeleteJobsite } from "./DeleteJobsite";
import { toast } from "react-toastify";
import { filterData } from "./filterData";
import { GetPropertyArea } from "./GetPropertyArea";
import { GetJobsite } from "./GetJobsites";
import { GetContacts } from "./GetContacts";
import Icon from "../../../components/icon";
import NProgress from "react-nprogress";
import { DeleteContact } from "./DeleteContact";
import { SaveContact } from "./SaveContacts";
import { GetAlerts } from "./GetAlerts";
import { SaveIndividual } from "./SaveIndividual";
import { DeleteCustomer } from "./DeleteCustomer";
import _ from 'lodash';
import { getTimeZone } from "../../../components/US_Timezones";
import { useDropzone } from "react-dropzone";
import { SaveBulkCustomer } from "./BulkSave";
import { exportToCSV } from "../../../components/export-components/ExportToCSV";
import { getCurrentDate,convertESTToLocalDateTime } from "../../../components/formatDate";
import ExportToExcel from "../../../components/export-components/ExportExcel";
import { SaveBillingInfo, GetBillingInfo } from "./BillingInfoLogic"
import dayjs from "dayjs";
import { getCounties } from "components/USTimezone_county";
import { GetEmployees } from "screens/Employees/logic/GetEmployees";

export const useCustomerLogic = ({activeStep = 0, setActiveStep, steps, setOpenNewCustomerDlg, fetchData, allCustomers }) => {

  //#region Constants  
  const theme = useTheme();
  const navigate = useNavigate();
  const contentHeightFixed = false; 

  const StepJobsite = styled(MuiStep)(({ theme }) => ({
    "& .MuiStepLabel-root": {
      paddingTop: 0,
    },
    "& .MuiStepLabel-iconContainer": {
      display: "none",
    },
    "& .step-subtitle": {
      color: `${theme.palette.text.disabled} !important`,
    },
    "& + svg": {
      color: theme.palette.text.disabled,
    },
    "&.Mui-completed .step-title": {
      color: theme.palette.text.disabled,
    },
  }));

  const tagManagementData = { title: 'Tag Management' }

  const InitialpropertyArea = {
    propertyAreaID: 0,
    jobsiteID: 0,
    propertyAreaType: 'Indoor',
    propertyAreaName: null,
    description: null,
    measurement: null,
  }

  const keysToKeep = [
    'customerID',
    'customerType',
    'companyName',
    'firstName',
    'companyAddress_Street1',
    'createDate',
    'createdBy',
    'modifiedDate',
    'modifiedBy',
    'referredBy',
    'isActive',
    'isLead',
    'tags',
  ];

  const mandatoryFields = [
    { key: "firstName", displayName: "First Name" },
    { key: "lastName", displayName: "Last Name" },
    { key: "companyName", displayName: "Company Name" },
    { key: "email", displayName: "Email" },
    { key: "phoneNumbers", displayName: "Phone Number" },
    { key: "companyAddress_Street1", displayName: "Address" },
    { key: "companyAddress_City", displayName: "City" },
    { key: "companyAddress_ZipCode", displayName: "Zip Code" },
    { key: "companyAddress_State", displayName: "State" }, 
     { key: "billingAddress_Street1", displayName: "Billing Address" },
  { key: "billingAddress_City", displayName: "Billing City" },
  { key: "billingAddress_ZipCode", displayName: "Billing Zip Code" },
  { key: "billingAddress_State", displayName: "Billing State" },
  ];

  const columnsAddContact = [
    {
      flex: 0.1,
      hide: true,
      field: "id",
      minWidth: 80,
      headerName: "ID",
      renderCell: ({ row }) => {
        const { id } = row;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography sx={{ flexGrow: 1 }}>{id}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "contact",
      minWidth: 120,
      headerName: "Contact",
      renderCell: ({ row }) => {
        const { firstName, lastName, email } = row;
  
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Typography noWrap>{firstName} {lastName}</Typography>
            <Typography noWrap variant="caption">
              {email}
            </Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "jobTitle",
      minWidth: 120,
      headerName: "Job Title",
      renderCell: ({ row }) => {
        const { jobTitle } = row;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <CustomChip
              rounded
              size="small"
              skin="light"
              sx={{ lineHeight: 1 }}
              color="secondary"
              label={jobTitle}
            />
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      sortable: false,
      field: "isPrimary",
      minWidth: 120,
      headerName: "Contact Type",
      renderCell: ({ row }) => {
        const { primary } = row;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            {primary === true && (
              <CustomChip
                rounded
                size="small"
                skin="light"
                sx={{ lineHeight: 1 }}
                color="success"
                label="Primary"
              />
            )}
            {primary === false && (
              <CustomChip
                rounded
                size="small"
                skin="dark"
                sx={{ lineHeight: 1 }}
                color="secondary"
                label="Mark as Primary"
                onClick={ () => {handleMarkAsPrimary(row.id)} }
                disabled={isMarkingPrimary}
              />
            )}
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      sortable: false,
      field: "actions",
      minWidth: 100,
      headerName: "Actions",
      renderCell: ({row}) => {
        const { primary } = row
  
        return (
          <Box>            
            <IconButton onClick={() => handleEditContactClick(row.id)}>
              <Icon icon="tabler:pencil" />
            </IconButton>
            { !primary && (
              <IconButton color='error' onClick={() => handleDeleteContact(row.id)}>
                <Icon icon="tabler:trash" />
              </IconButton>
            ) }
          </Box>
        )
      },
    },
  ];

  //#endregion End of Constants

  //#region States

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [bulkCusType, setBulkCusType] = useState(0);
  const [bulkCusStatus, setBulkCusStatus] = useState(0);
  const [bulkCusLead, setBulkCusLead] = useState(0);
  const [bulkTags, setBulkTags] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [data, setData] = useState([]);
  const [paginationText, setPaginationText] = useState('');
  const [paginationModelAddContact, setPaginationModelAddContact] = useState({
    page: 0,
    pageSize: 5,
  });
  //const [openNewCustomerDlg, setOpenNewCustomerDlg] = useState(false);
  const [openNewContactDlg, setOpenNewContactDlg] = useState(false);
  const [jobsiteIsEmpty, setJobsiteIsEmpty] = useState(true);
  const [openNewJobsiteDlg, setOpenNewJobsiteDlg] = useState(false);
  const [customerType, setCustomerType] = useState("individual");
  const [phoneFields, setPhoneFields] = useState([
    { phoneNo: "", isPrimary: true },
  ]);
  const initialCustomerState = {
    customerID: 0,
    customerType: 'individual',
    firstName: '',
    lastName: '',
    createDate: null,
    createBy: null,
    modifiedDate: null,
    modifiedBy: null,
    isActive: true,
    companyName: '',
    email: '',
    isLead: false,
    referredBy: null,
    soldBy: null,
    companyAddress_Street1: '',
    companyAddress_Street2: '',
    companyAddress_FloorLevel: '',
    companyAddress_UnitNumber: '',
    companyAddress_City: '',
    companyAddress_State: '',
    companyAddress_ZipCode: '',
    companyAddress_County: '',
    billingAddress: true,
    billingAddress_Street1: '',
    billingAddress_Street2: '',
    billingAddress_FloorLevel: '',
    billingAddress_UnitNumber: '',
    billingAddress_City: '',
    billingAddress_State: '',
    billingAddress_ZipCode: '',
    billingAddress_County: '',
    timeZone: '',
    phoneNumbers: phoneFields,
    createdBy: null,
    tags: [],
  }

  const [openTagManagementDlg,setOpenTagManagementDlg] = useState(false);
  
  const [customer, setCustomer] = useState(initialCustomerState);
  //const [allCustomers, setAllCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [searchContactText, setSearchContactText] = useState("");
  const [searchJobsiteText, setSearchJobsiteText] = useState("");
  const [filterType, setFilterType] = useState('ALL');
  const [selectedButton, setSelectedButton] = useState(0);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState(0);
  const [billingAddressCheck, setBillingAddressCheck] = useState(true);
  const [modalData, setModalData] = useState({ title: 'Create Customer', btnTxt: 'Create Customer', successTitle: 'Create Customer', successTxt: 'Customer has been successfully created.' });
  const [phoneError, setPhoneError] = useState({});
  const [contactPhoneError, setContactPhoneError] = useState({});
  const [errors, setErrors] = useState({});
  const [errorContacts, setErrorContacts] = useState({}); //165
  const [isEditing, setIsEditing] = useState(false);
  const [quickViewOpen, setQuickViewOpen] = useState(false); //167
  const [billingAddressChange, setBillingAddressChange] = useState(false);
  const [openQuickViewContact, setOpenQuickViewContact] = useState(false);
  const [openQuickViewPropArea, setOpenQuickViewPropArea] = useState(false);
  const [openBulkImportDlg, setOpenBulkImportDlg] = useState(false);
  const [EmpFiles, setEmpFiles] = useState([]);
  const [files, setFiles] = useState([])
  const [btnLoader, setBtnLoader] = useState(false);
  const [isValidPhone, setIsValidPhone] = useState({ 0: true });
  const [isValidContactPhone, setIsValidContactPhone] = useState({ 0: true });
  const [customerID, setCustomerID] = useState(0);
  const isDeletingRef = useRef(false); // Track deletion outside state to prevent double calls
  const [isDeleting, setIsDeleting] = useState(false); //179
  const [openUpdateContactDlg, setUpdateContactDlg] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [showConfirmAlert, setShowConfirmAlert] = useState(true);
  const MySwal = withReactContent(Swal);
  const [isMarkingPrimary, setIsMarkingPrimary] = useState(false);

  
  // const [estTravelTime, setEstTravelTime] = useState(false);
  const [depositReq, setDepositReq] = useState(false);
  const [depositType, setDepositType] = useState("percentage");
// Add to your states section with other state declarations
  const [billingFrequencyID, setBillingFrequencyID] = useState(0);
  const [billingFreq,    setBillingFreq]    = useState('select')
  const [recurringType,  setRecurringType]  = useState('weekly')
  const [formatsBilling, setFormatsBilling] = useState('')
  const [formatsBillingWeekly , setFormatsBillingWeekly] = useState('')
  const [monthlyOptions, setMonthlyOptions] = useState('billingDay')

  // new states
  // const [occurrences, setOccurrences] = useState(1)
  const [cycleStartDate, setCycleStartDate] = useState(null)
  const [intervalDaysInput, setIntervalDaysInput] = useState(0)
  const [weekOfMonth, setWeekOfMonth] = useState('first')
  const [quarter, setQuarter] = useState('Q1')
  const [monthOfQuarter, setMonthOfQuarter] = useState(1)

  const initialJobsiteState = {
    jobsiteID: 0,
    customerID: customer?.customerID,
    jobsiteType: 'Residential',
    jobsiteName: null,
    street1: null,
    street2: null,
    floorLevel: null,
    unitNumber: null,
    city: null,
    state: null,
    zipCode: null,
    county: null,
    billingAddress: false,
    contact: null,
  }
  const [jobsite, setJobsite] = useState(initialJobsiteState);
  
  const [Oldjobsite, setOldJobsite] = useState();

  const [allJobsites, setAllJobsites] = useState([]);
  const [alertList, setAlertList] = useState([]);

  const [BulkImportContent, setBulkImportContent] = useState({title:'', ImportURL:''});

  const [contactID, setContactID] = useState(0);
  const initialContact = {
    contactID: 0,
    firstName: null,
    lastName: null,
    email: null,
    jobTitle: null,
    customerID: 0,
    isPrimary: true,
    phoneNumbers:phoneFields,
    status:'active'
  }
  const [contact, setContact] = useState(initialContact);
  const [allContacts, setAllContacts] = useState([]);
  const [propertyArea, setPropertyArea] = useState(InitialpropertyArea);
  const [areaMeasurement, setAreaMeasurement] = useState({
    measurementID: 0,
    measurementName: null,
    unitOfMeasure: null,
    length: 0,
    width: 0,
    height: 0,
    total: 0,
  });
  const [propertyAreaList, setPropertyAreaList] = useState([]);
  const [jobsiteContent, setJobsiteContent] = useState({ title: "Create Jobsite", notification: "Jobsite saved successfully.", mode: 'create' })

  const [activeStepJobsite, setActiveStepJobsite] = useState(0);

  const [isContactSaved, setIsContactSaved] = useState(false);
  const [sortDirection, setSortDirection] = useState('asc');

  const [allEmployees, setAllEmployees] = useState([]);

  const toggleSortDirection = () => {
    setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
  };
  //#endregion end of states

  //#region Handlers and methods
  // const handleEstTravelTimeChange = () => setEstTravelTime(!estTravelTime);

  useEffect(() => {
    const fetchAllEmployees = async () => {
      try{
        const result = await GetEmployees(0, navigate);

        if(result){
          setAllEmployees(result);
        }
      }catch(error){
        console.error(error)
      }
    };

    fetchAllEmployees();
  }, [])

  // useEffect(() => {
  //   console.log('customer', customer)
  // }, [customer])
  

  const handleBillingFreqChange = (value) => setBillingFreq(value);
  const handleRecurringTypeChange = (value) => {
    setRecurringType(value);
    setFormatsBilling('');
    setCycleStartDate(null);
  }

  const handledDepositReqChange = () => setDepositReq(!depositReq);
  const handleDepositTypeChange = (value) => setDepositType(value);

  const handleFormatBilling = (event, newFormat, billingType) => {
    if (billingType === 'weekly') {
      setFormatsBilling(newFormat || '');
    } else if (billingType === 'bi-weekly') {
      setFormatsBilling(newFormat || '');
    }
  };  

const handleDeleteContact = useCallback(async (contactID) => {
  if (isDeletingRef.current) return; // Guard: prevent double deletion

  isDeletingRef.current = true;
  setIsDeleting(true);
  NProgress.start();

  try {
    const result = await DeleteContact(contactID, customer.customerID, navigate);

    if (result && !result.isError) { 
      await fetchContacts(customer?.customerID);

      toast.success(result.message || `Contact deleted successfully.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { fontFamily: '"DM Sans", sans-serif', fontSize: '15px' },
      });
    } else {
      toast.error(result.message || 'Failed to delete the contact.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { fontFamily: '"DM Sans", sans-serif', fontSize: '15px' },
      });
    }
  } catch (error) {
    console.error('Error deleting contact:', error);
  } finally {
    NProgress.done();

    // Only update state if it actually changed
    setIsDeleting(prev => (prev ? false : prev));
    isDeletingRef.current = false; // Reset the ref
  }
}, [customer?.customerID, navigate]);


  const handleDebouncedChange = useCallback(
    debounce((field, value, setCustomer, validateIndiviual) => {
      setCustomer((prevState) => ({ ...prevState, [field]: value }));
  
      // Validate if it's a mandatory field
      if (mandatoryFields.filter((f) => f.key === field).length > 0) {
        validateIndiviual(field, value);
      }
    }, 300), // Adjust the debounce delay as needed
    []
  );

  const handleJobsiteDelete = async (jobsiteID, jobsiteName) => {
    
    try {
      const result = await MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: `<span>Are you sure you want to delete ${jobsiteName} jobsite?</span>`,
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
     width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
          cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  });
  
      // console.log("Swal result:", result);
     

      if (result.isConfirmed) {
        setLoading(true);    
        const deleteResult = await DeleteJobsite(jobsiteID, customer?.customerID, navigate);
        
        if (deleteResult && !deleteResult.isError) {
          fetchJobsites();
          toast.success(`"${jobsiteName}" Jobsite deleted successfully.`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        } else {
          toast.error(deleteResult.message || 'Failed to delete the jobsite.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      }
    } catch (error) {
      console.error('Error deleting jobsite:', error);
    } finally {
      setLoading(false);
    }
  }

  const handleJobsiteEdit = (jobsiteID) => {
    let getJobSite = allJobsites.filter(x => x.jobsiteID = jobsiteID)[0];
    setJobsite(getJobSite);
    setOldJobsite(getJobSite);
    setActiveStepJobsite(0);
    fetchContacts(customer?.customerID);
    fetchPropertyArea(getJobSite?.jobsiteID);
    setOpenNewJobsiteDlg(true);
    setJobsiteContent({ title: "Edit Jobsite", notification: `Jobsite updated successfully.`, mode: 'edit' });
  }

  const handleJobsiteChange = (field, value) => {
    if(field === 'billingAddress'){
        if(!value){
          setJobsite((prevState) => ({ ...prevState,
            [field]: value ,
            ['street1']:'',
            ['street2']:'',
            ['floorLevel']:'',
            ['unitNumber']:'',
            ['city']:'',           
            ['state']:'',
            ['zipCode']:'',
            ['county']:'',
          })); 
        }else{
          setJobsite((prevState) => ({ ...prevState,
            [field]: value ,
            ['street1']:customer?.companyAddress_Street1 || '',
            ['street2']:customer?.companyAddress_Street2 || '',
            ['floorLevel']:customer?.companyAddress_FloorLevel || '',
            ['unitNumber']:customer?.companyAddress_UnitNumber || '',
            ['city']:customer?.companyAddress_City || '',           
            ['state']:customer?.companyAddress_State || '',
            ['zipCode']:customer?.companyAddress_ZipCode || '',
            ['county']:customer?.companyAddress_County || '',
          })); 
        }      
      }
      else if(field.includes("zipCode")){
        if(isNumberOnly(value)){
          setJobsite((prevState) => ({ ...prevState, [field]: value }));
        }
        else{
        setJobsite((prevState) => ({ ...prevState, [field]: value }));
      }        
    }else{
      setJobsite((prevState) => ({ ...prevState, [field]: value }));    
    }    
  };

 const handleChange = async (field, value) => {
  const nameRegex = /^[A-Za-z]+$/;
  if (field === "firstName" || field === "lastName") {
    if (value && !nameRegex.test(value)) {
      return;
    }
  }

  const updateCustomer = () => {
    setCustomer((prevState) => ({ ...prevState, [field]: value }));

    if (mandatoryFields.some((f) => f.key === field)) {
      validateIndiviual(field, value);
    }
  };

  const zipCodeRegex = /^\d{0,5}$/;
  if (field.includes("ZipCode")) {
    if (zipCodeRegex.test(value)) {
      updateCustomer();

      if (value.length === 5) {
        const timezone = await getTimeZone(value);
        const { county } = await getCounties(value);

        // Determine which address to update based on the field name
        if (field.includes("billingAddress")) {
          setCustomer((prevState) => ({
            ...prevState,
            billingAddress_County: county,
          }));
        } else {
          setCustomer((prevState) => ({
            ...prevState,
            timeZone: timezone,
            companyAddress_County: county,
          }));
        }
      }
    }
  } else {
    updateCustomer();
  }
};
  
  const handleContactChange = (field, value) =>{
    setContact((prevState) => ({ ...prevState, [field]: value }));
  }

  const handleAreaMeasurement = (field, value) => {
    if (field === 'total' || field === 'length' || field === 'width' || field === 'height') {
      if (isNumberOnly(value)) {
        setAreaMeasurement((prevState) => ({ ...prevState, [field]: value }));
      }
    } else if (field === 'unitOfMeasure') {
      setAreaMeasurement((prevState) => ({ ...prevState, [field]: value, ['length']: '', ['width']: '', ['height']: '' }));
    } else {
      setAreaMeasurement((prevState) => ({ ...prevState, [field]: value }));
    }
  };

  const handleCloseUpdateDlg = () => setUpdateContactDlg(false);

  const fetchPropertyArea = async (jobsiteID, PropertyAreaID = 0) => {
    try {      
      let PA = await GetPropertyArea(jobsiteID, PropertyAreaID, navigate);
      setPropertyAreaList(PA);
    } catch (error) {
      console.error("Error fetching PropertyArea data:", error);
    } finally {
    }
  };

  const fetchJobsites = async (customerID = customer?.customerID) => {
    try {
      let job = await GetJobsite(customerID, 0, navigate);
      setAllJobsites(job);  
      
    } catch (error) {
      console.error("Error fetching Jobsite data:", error);
    } finally {
    }
  };

  const fetchContacts = async (customerID = customer?.customerID) => {
    if (customerID > 0) {
      try {
        let con = await GetContacts(customerID);
        setAllContacts(con);
      } catch (error) {
        console.error("Error fetching Customer data:", error);
      } finally {
      }
    } else {
      setAllContacts([]);
    }

  };

  const clearAreaMeasurement = () => {
    setAreaMeasurement({
      measurementName: null,
      unitOfMeasure: null,
      length: 0,
      width: 0,
      height: 0,
      total: 0,
    });
  }

  const clearPropertyArea = () => {
    setPropertyArea(InitialpropertyArea);
  }

  const validateIndiviual = (field, value) => {
    const fieldInfo = mandatoryFields.find((f) => f.key === field);
    let displayName = fieldInfo?.displayName || field;

    if (value) {
      setErrors((prevState) => ({ ...prevState, [field]: '' }));
    } else {
      setErrors((prevState) => ({
        ...prevState,
        [field]: `${displayName} is required.`
      }));
    }
    console.log('errors', errors)
  }

  const isNumberOnly = (input) => {
    const numberRegex = /^\d*$/;
    return numberRegex.test(input);
  }

  const handleEditContactClick = (id) => {
    setContactID(id);
    handleUpdateContactDlg();
  }

  const handleMarkAsPrimary = (id) =>{
    const updatedContacts = allContacts.map(con => ({
      ...con,
      isPrimary: con.id === id ? true : false 
    }));
  
    const contactData = updatedContacts.map(con=> ({
      contactID: con.id,
      firstName: con.firstName,
      lastName: con.lastName,
      email: con.email,
      jobTitle: con.jobTitle,
      customerID: customer.customerID,
      isPrimary: con.isPrimary,
      status: con.status
    }));

     SaveCon(contactData);
    
  }

  const SaveCon = async (contactData) =>{    
    try {       
      setIsMarkingPrimary(true);                 
      const response = await SaveContact(contactData, navigate);
      //console.log(response);
      if (response && !response.isError) {                       
        fetchContacts(customer?.customerID);          
        toast.success(`Updated! Contacts have been saved.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });               
      } else {
        toast.error(`Failed! ${response.result[0].failureReason}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });                           
      }
    } catch (error) {        
      console.error('Error saving contacts:', error);          
    }finally {
      setIsMarkingPrimary(false)
    }
  }

  const handleUpdateContactDlg = () => setUpdateContactDlg(true);

  const handleQuickViewClose = () => {
    setQuickViewOpen(false);
    setPropertyAreaList([]); 
    setAllContacts([]);
    setAlertList([]);
    setJobsite(initialJobsiteState);
  };

  const handleQuickViewOpen = (jobsiteID) => {
    let getJobSite = allJobsites.filter(x => x.jobsiteID === jobsiteID)[0];
    fetchAlerts(jobsiteID);
    fetchContacts();
    fetchPropertyArea(jobsiteID);
    setJobsite(getJobSite);  
    setQuickViewOpen(true);
  }

  const fetchAlerts = async(jobsiteID) =>{
    try {
      let alrts = await GetAlerts(jobsiteID,0,navigate);      
      setAlertList(alrts);           
    } catch (error) {
      console.error("Error fetching Alerts data:", error);
    } finally {
    }
  }

  const handlePhoneFieldChange = (index, value) => {
    const phoneRegex = /^\d{10}$/;

    const isDuplicate = customer && Array.isArray(customer.phoneNumbers) && 
      customer.phoneNumbers.some((phoneNumber, i) => 
        phoneNumber && 
        phoneNumber.phoneNo && 
        i !== index && 
        phoneNumber.phoneNo === value && 
        value !== '' && 
        value.length >= 10
      );

    const isValidFormat = phoneRegex.test(value);

    if (value && value.startsWith('1')) {
      setPhoneError((prev) => {       
        return {
          ...prev,
          [index]: "Area code cannot begin with 1.",
        };
      });
      setIsValidPhone((prev)=>({
        ...prev,
        [index]: false
      }));
    } else if (isDuplicate) {
      setPhoneError((prev) => {
        return {
          ...prev,
          [index]: "Phone number already exists.",
        };
      });
      setIsValidPhone((prev) => ({
        ...prev,
        [index]: false
      }));
    } else if (!isValidFormat && value !== '' && value.length < 10) {
      // Only show "Invalid phone number" if they've typed something but it's not 10 digits
      setPhoneError((prev) => {
        return {
          ...prev,
          [index]: "Invalid phone number.",
        };
      });
      setIsValidPhone((prev) => ({
        ...prev,
        [index]: false
      }));
    } else if (value === '') {
      setPhoneError((prev) => {
        return {
          ...prev,
          [index]: "Phone number is required.",
        };
      });
      setIsValidPhone((prev) => ({
        ...prev,
        [index]: false
      }));
    } else {
      setPhoneError((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
      setIsValidPhone((prev) => ({
        ...prev,
        [index]: true
      }));
    }

    const updatedPhoneNumbers = customer.phoneNumbers.map((phoneNumber, i) => {
      if (i === index && index === 0 && customer.phoneNumbers.filter(x => x.isPrimary === true).length === 0) {
        return { ...phoneNumber, phoneNo: value, isPrimary: true };
      } else if (i === index) {
        return { ...phoneNumber, phoneNo: value };
      } else {
        return phoneNumber;
      }
    });
    
    setCustomer((prev) => ({
      ...prev,
      phoneNumbers: updatedPhoneNumbers,
    }));
  };

  const handleContactPhoneFieldChange = (index, value) => {
    const phoneRegex = /^\d{10}$/;

    const isDuplicate = contact && Array.isArray(contact.phoneNumbers) && 
      contact.phoneNumbers.some((phoneNumber, i) => 
        phoneNumber && 
        phoneNumber.phoneNo && 
        i !== index && 
        phoneNumber.phoneNo === value && 
        value !== '' && 
        value.length >= 10
      );

    const isValidFormat = phoneRegex.test(value);

    if (value && value.startsWith('1')) {
      setContactPhoneError((prev) => ({
        ...prev,
        [index]: 'Area code cannot begin with 1.',
      }));
      setIsValidContactPhone((prev) => ({
        ...prev,
        [index]: false
      }));
    } else if (isDuplicate) {
      setContactPhoneError((prev) => ({
        ...prev,
        [index]: 'Phone number already exists.',
      }));
      setIsValidContactPhone((prev) => ({
        ...prev,
        [index]: false
      }));
    } else if (!isValidFormat && value !== '' && value.length < 10) {
      setContactPhoneError((prev) => ({
        ...prev,
        [index]: 'Invalid phone number.',
      }));
      setIsValidContactPhone((prev) => ({
        ...prev,
        [index]: false
      }));
    } else if (value === '') {
      setContactPhoneError((prev) => ({
        ...prev,
        [index]: 'Phone number is required.',
      }));
      setIsValidContactPhone((prev) => ({
        ...prev,
        [index]: false
      }));
    } else {
      setContactPhoneError((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
      setIsValidContactPhone((prev) => ({
        ...prev,
        [index]: true
      }));
    }

    const updatedPhoneNumbers = contact.phoneNumbers.map((phoneNumber, i) => {
      if (i === index && index === 0 && contact.phoneNumbers.filter(x => x.isPrimary === true).length === 0) {
        return { ...phoneNumber, phoneNo: value, isPrimary: true };
      } else if (i === index) {
        return { ...phoneNumber, phoneNo: value };
      } else {
        return phoneNumber;
      }
    });
    
    setContact((prev) => ({
      ...prev,
      phoneNumbers: updatedPhoneNumbers,
    }));
  };

  const handleSetPrimary = (index) => {
    const isDuplicate = customer.phoneNumbers.some((phoneNumber, i) => 
      i !== index && phoneNumber.phoneNo === customer.phoneNumbers[index].phoneNo // Check for duplicates excluding the current
    );
    if (!isDuplicate) {
      const updatedPhoneNumbers = customer.phoneNumbers.map((phoneNumber, i) => {
        return { ...phoneNumber, isPrimary: i === index }; // Set current as primary and others as not primary
      });

      setCustomer((prev) => ({
        ...prev,
        phoneNumbers: updatedPhoneNumbers,
      }));
    }
  };

  const handleSetPrimaryContact = (index) => {
    const isDuplicate = contact.phoneNumbers.some((phoneNumber, i) => 
      i !== index && phoneNumber.phoneNo === contact.phoneNumbers[index].phoneNo // Check for duplicates excluding the current
    );
    if (!isDuplicate) {
      const updatedPhoneNumbers = contact.phoneNumbers.map((phoneNumber, i) => {
        return { ...phoneNumber, isPrimary: i === index }; // Set current as primary and others as not primary
      });

      setContact((prev) => ({
        ...prev,
        phoneNumbers: updatedPhoneNumbers,
      }));
    }
  };
  
  const handleDeletePhoneField = (index) => {
    const updatedPhoneNumbers = customer.phoneNumbers.filter((_, i) => i !== index);
    setCustomer((prev) => ({
      ...prev,
      phoneNumbers: updatedPhoneNumbers,
    }));
    setPhoneError((prev) => ({
      ...prev,
      [index]: '', 
    }));
  };

  const handleDeletePhoneFieldContact = (index) => {
    const updatedPhoneNumbers = contact.phoneNumbers.filter((_, i) => i !== index);
    setContact((prev) => ({
      ...prev,
      phoneNumbers: updatedPhoneNumbers,
    }));
    setContactPhoneError((prev) => ({
      ...prev,
      [index]: '', 
    }));
  };

  const handleAddPhoneField = () => {
    const phoneRegex = /^\d{10}$/;
    setCustomer((prev) => {
      const allPhoneNumbersValid = prev.phoneNumbers?.every((phone, index) => {
        const IsValidPhone = phone?.phoneNo?.trim() !== '' && phone?.phoneNo?.trim() !== '1' && phoneRegex.test(phone.phoneNo);       
        if (!IsValidPhone) {          
          setPhoneError((prevErrors) => ({
            ...prevErrors,
            [index]: 'Please enter a valid phone number before adding another.',
          }));
        } else {
          setPhoneError((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[index]; 
            return newErrors;
          });
        }
  
        return IsValidPhone;
      });
  
  
      if (allPhoneNumbersValid) {
        return {
          ...prev,
          phoneNumbers: [
            ...prev.phoneNumbers,
            { phoneNo: '', isPrimary: false },
          ],
        };
      } else {              
        return prev;
      }
    });
  };

  const handleAddPhoneFieldContact = () => {
    const phoneRegex = /^\d{10}$/;
    setContact((prev) => {
      const allPhoneNumbersValid = prev.phoneNumbers?.every((phone, index) => {
        const isValidContactPhone = phone?.phoneNo?.trim() !== '' && phone?.phoneNo?.trim() !== '1' && phoneRegex.test(phone.phoneNo);       
        if (!isValidContactPhone) {          
          setContactPhoneError((prevErrors) => ({
            ...prevErrors,
            [index]: 'Please enter a valid phone number before adding another.',
          }));
        } else {
          setContactPhoneError((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[index]; 
            return newErrors;
          });
        }
  
        return isValidContactPhone;
      });
  
  
      if (allPhoneNumbersValid) {
        return {
          ...prev,
          phoneNumbers: [
            ...prev.phoneNumbers,
            { phoneNo: '', isPrimary: false },
          ],
        };
      } else {              
        return prev;
      }
    });
  };

  const handleSearchChange = (searchKeyWord) => {
    setSearchText(searchKeyWord);
  };

  const handleClearContactSearch = () => {
    handleContactSearchChange("");
  };

  const handleContactSearchChange = (searchKeyWord) => {
    setSearchContactText(searchKeyWord);
  };

  const handleClearJobsiteSearch = () => {
    handleJobsiteSearchChange("");
  };

  const handleJobsiteSearchChange = (searchKeyWord) => {
    setSearchJobsiteText(searchKeyWord);
  };

  const filteredContactRows = (allContacts || [])
  .filter(row =>    
      Object.values(row).some(value =>
          value && value.toString().toLowerCase().includes(searchContactText.toLowerCase())
      )
  );

  const handleOpenNewContactDlg = () => {
    setOpenNewContactDlg(true);
  }

  const handleContactPaginationModel = (model) =>{
    if(model.pageSize === filteredContactRows.length){
      setPaginationModelAddContact({
        page: 0,
        pageSize: filteredContactRows.length,
      })
    }else{
      setPaginationModelAddContact(model);
    }  
  }

  const handleOpenNewCustomerDlg = () => {    
    setOpenNewCustomerDlg(true);
  };

  const handleOpenNewJobsiteDlg = () => {
    setJobsite(initialJobsiteState);
    fetchContacts(customer?.customerID);
    setActiveStepJobsite(0);
    setOpenNewJobsiteDlg(true);
    setFiles([]);
    setJobsiteContent({title:"Create Jobsite", notification:"Jobsite saved successfully.", mode: 'create'});
  }
const saveOrUpdateBillingInfo = async () => {
  if (!billingFreq || billingFreq === 'select' || !customer?.customerID) {
    return;
  }
  
  try {
    // Check if billing info already exists
    const existingBilling = await GetBillingInfo(customer.customerID);
    
    if (existingBilling && !existingBilling.isError && existingBilling.result) {
      const updatedBillingObject = buildBillingPayload(
        customer.customerID, 
        existingBilling.result.billingFrequencyID
      );
      const result = await SaveBillingInfo(updatedBillingObject);
      
      if (result && !result.isError) {
        setBillingFrequencyID(existingBilling.result.billingFrequencyID);
        return result;
      }
    } else {
      const result = await handleSaveBillingInfo(customer.customerID, billingFrequencyID || 0);
      return result;
    }
  } catch (error) {
    console.warn('Failed to save billing info:', error);
    try {
      return await handleSaveBillingInfo(customer.customerID, 0);
    } catch (err) {
      console.warn('Both create and update failed for billing info:', err);
    }
  }
};
 const handleNext = async () => {
  if (validateFields(activeStep)) {
    NProgress.start();
      
    if (activeStep === 0) {
      let DubCustomers = GetDuplicates();
        if(DubCustomers.length > 0 && customer.customerID !== DubCustomers.filter(x => x.customerID === customer.customerID).customerID){
          let List = getDubContent(DubCustomers) ;
         MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: List,
    showCancelButton: true,
    confirmButtonText: 'Save Customer',
    cancelButtonText: 'Cancel',
    width: '440px', // Explicit width control
    padding: '1rem',
    focusConfirm: false,
    showCloseButton: true,
    reverseButtons: false,
    closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
        title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
        htmlContainer: 'custom-swal-html',
        confirmButton: 'custom-swal-confirm',
        cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
        closeButton: 'custom-swal-close'
    }
  }).then(async (result) => {
            if (result.isConfirmed) {
              let response = await SaveCus();
              if (response?.isError) {
                toast.error(`Failed! ${response.message}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
                });
                NProgress.done();
                return;
              }
              handleChange('customerID', response.result?.customerID);                
              fetchContacts(response.result?.customerID);
              setActiveStep((prevActiveStep) => prevActiveStep + 1);    
            }
            NProgress.done();
          });
        } else {
          let response = await SaveCus();   
          if(response?.isError){
            toast.error(`Failed! ${response.message}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
            });
            NProgress.done();
            return;
          }
          handleChange('customerID', response.result?.customerID);                
          fetchContacts(response.result.customerID);
          setActiveStep((prevActiveStep) => prevActiveStep + 1);                 
        }                
    } else if(activeStep === 1) {
      if(allContacts.length > 0){          
        if(customer?.autoGenerateInvoice && (!billingFreq || billingFreq == 'select')){
          toast.error(`Please select billing frequency to automate invoice creation.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
                  style: {
                    fontFamily: '"DM Sans", sans-serif',
                    fontSize: '15px',
                  },
          }); 
          return;
        }

        fetchJobsites();
        
        await saveOrUpdateBillingInfo();
     
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        
      } else {
        toast.error(`Failed! Please create at least one Contact`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
        NProgress.done();
      }  
    } else if(activeStep === steps.length - 1) {
      if(allJobsites.length > 0){
        setIsCompleted(true);
        setOpenNewCustomerDlg(false);
        fetchData();
        setActiveStep(0);
        resetCustomer();
        if(customer.customerID > 0){
          toast.success(`Customer Created successfully.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
          });
        }  
      } else {
        toast.error(`Failed! Please create at least one Jobsite`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
            style: {
              fontFamily: '"DM Sans", sans-serif',
              fontSize: '15px',
            },
        });
        NProgress.done();
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      NProgress.done();
    }
    // NProgress.done() is called in each branch above
  } else {
    // Validation failed, ensure NProgress is stopped
    NProgress.done();
  }
};

// ----- Clear errors -----
useEffect(() => {
  if (Object.keys(errors).length === 0) return;

  const timer = setTimeout(() => {
    setErrors(prev => (Object.keys(prev).length === 0 ? prev : {}));
  }, 5000);

  return () => clearTimeout(timer);
}, [errors]);

// ----- Clear phone errors -----
useEffect(() => {
  if (Object.keys(phoneError).length === 0) return;

  const timer = setTimeout(() => {
    setPhoneError(prev => (Object.keys(prev).length === 0 ? prev : {}));
  }, 5000);

  return () => clearTimeout(timer);
}, [phoneError]);

// ----- Reset phone validity -----
useEffect(() => {
  if (Object.keys(isValidPhone).length === 1 && isValidPhone[0] === true) return;

  const timer = setTimeout(() => {
    setIsValidPhone(prev => {
      if (prev[0] === true && Object.keys(prev).length === 1) return prev;
      return {0: true};
    });
  }, 5000);

  return () => clearTimeout(timer);
}, [isValidPhone]);


// useEffect(() => {
//   if (Object.keys(errorContacts).length > 0) {
//     const timer = setTimeout(() => {
//       setErrorContacts({});
//     }, 5000);

//     return () => clearTimeout(timer);
//   }
// }, [errorContacts]);   // It was causing rerenders

useEffect(() => {
  if (!errorContacts || Object.keys(errorContacts).length === 0) return;

  const timer = setTimeout(() => {
    setErrorContacts(prev =>
      Object.keys(prev).length === 0 ? prev : {}
    );
  }, 5000);

  return () => clearTimeout(timer);
}, [errorContacts]);


  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const validateFields = (step) => {
    let tempErrors = {};
    const nameRegex = /^[A-Za-z]+$/;

    PhoneResolve();
    if(step === 0){
      if (!customer.customerType) tempErrors.customerType = 'Customer Type is required';
      if(customer.customerType === 'individual'){
        if (!customer.firstName) tempErrors.firstName = 'First Name is required';
        if (customer.firstName) {
          if (!nameRegex.test(customer.firstName)) tempErrors.firstName = 'Only alphabets are accepted';
        }
        if (!customer.lastName) tempErrors.lastName = 'Last Name is required';
        if (customer.lastName){
          if (!nameRegex.test(customer.lastName)) tempErrors.lastName = 'Only alphabets are accepted';
        }
      }else{
        // if (!customer.firstName) tempErrors.firstName = 'First Name is required';
        //if (!customer.billingAddress_UnitNumber) tempErrors.billingAddress_UnitNumber = 'Company Phone is required';
        if (!customer.companyName) tempErrors.companyName = 'Company Name is required';
      }
      if (!customer.email ) tempErrors.email = 'Email is required';
      if (Object.keys(phoneError).length > 0 && !isPhoneErrorEmpty() || (customer.phoneNumbers.length>0 && customer.phoneNumbers[0].phoneNo === '')) 
      {
        tempErrors.phoneError = 'Phone number is required';        
      }
      if (customer.email && !validateEmail(customer.email)) tempErrors.email = 'Enter a vaild Email';   
      if (customer.email && duplicateEmail(customer.email) && customer.customerID === 0) tempErrors.email = 'This email already exists.'; 
      if (!customer.companyAddress_Street1 ) tempErrors.companyAddress_Street1 = 'Address is required';      
      if (!customer.companyAddress_City ) tempErrors.companyAddress_City = 'City is required';      
      if (!customer.companyAddress_State ) tempErrors.companyAddress_State = 'State is required';      
      if (!customer.companyAddress_ZipCode ) tempErrors.companyAddress_ZipCode = 'Zip Code is required';
    }    
     if (!customer.billingAddress) {
      // Only validate billing address fields if billing address is enabled/checked
      if (!customer.billingAddress_Street1 ) tempErrors.billingAddress_Street1 = 'Billing Address is required';      
      if (!customer.billingAddress_City ) tempErrors.billingAddress_City = 'Billing City is required';      
      if (!customer.billingAddress_State ) tempErrors.billingAddress_State = 'Billing State is required';      
      if (!customer.billingAddress_ZipCode ) tempErrors.billingAddress_ZipCode = 'Billing Zip Code is required';
      
      // Optional: Add zip code format validation for billing address
      if (customer.billingAddress_ZipCode && !/^\d{5}$/.test(customer.billingAddress_ZipCode)) {
        tempErrors.billingAddress_ZipCode = 'Billing Zip Code must be 5 digits';
      }
    }
    
    setErrors(tempErrors);  
    let validateContact = validateContactFields();  
    return (Object.keys(tempErrors).length === 0 && validateContact);
  };

  const validateContactFields = () => {
    
    let tempErrors = {};
    const nameRegex = /^[A-Za-z]+$/;
    PhoneResolveContact();
      if(customer?.customerType === 'business'){
        if (!contact.firstName) tempErrors.firstName = 'First Name is required';
        if (contact.firstName) {
          if (!nameRegex.test(contact.firstName)) tempErrors.firstName = 'Only alphabets are accepted';
        }
        if (!contact.lastName) tempErrors.lastName = 'Last Name is required';
        if (contact.lastName){
          if (!nameRegex.test(contact.lastName)) tempErrors.lastName = 'Only alphabets are accepted';
        }
        if (!contact.email) tempErrors.email = 'Email is required';        
        if (contact.email && !validateEmail(contact.email)) tempErrors.email = 'Enter a vaild Email'; 
         if (contact.email && duplicateEmail(contact.email) && contact.contactID === 0) tempErrors.email = 'This email already exists.';
        
        if (!contact.jobTitle) tempErrors.jobTitle = 'Job Title is required'; 
        if (Object.keys(contactPhoneError).length > 0 && !isPhoneErrorEmptyContact() || (contact.phoneNumbers.length>0 && contact.phoneNumbers[0].phoneNo === '')) 
          {
            tempErrors.contactPhoneError = 'Phone number is required';        
          }
      }                         
    setErrorContacts(tempErrors);   
    // console.log(customer?.customerType,errorContacts) ;
    return Object.keys(tempErrors).length === 0;
  };

  const GetDuplicates = () => {
    let DublicateCustomers = allCustomers?.filter(x => (x.firstName.trim() === customer?.firstName.trim() && x?.firstName.trim() !== '') && (x.lastName.trim() === customer?.lastName.trim() && x?.lastName.trim() !== ''));
    return DublicateCustomers ; 
  }

  const duplicateEmail = (email) => {    
    return allCustomers?.filter(x => x.email === email).length > 0;; 
  }

 
  const getDubContent = (dubCustomer) =>{   
    let content = `One or more customers named "${customer?.firstName} ${customer?.lastName}" already exist:</br>`;
    content +=`
    <style>  
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
      margin-top: 10px;
    }
    th {
      background-color: #f4f4f4;
      position: sticky; /* Sticky header */
      top: 0; /* Position at the top */
      z-index: 2; /* Ensure it stays above the table rows */
    }
    th, td {
      text-align: left;
      border: 1px solid #ddd;
      padding:5px;
    }
  
    th {
      background-color: #f4f4f4;
    }
  
    tr:nth-child(even) {
      background-color: #f9f9f9;
    }
  
    tr:hover {
      background-color: #f1f1f1;
    }
  </style> 
  <div style="overflow-y: scroll;max-height: 222px;">
    <table style="width:100%"> 
                  <thead>
                    <tr>
                      <th>Row</th>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Action</th>                    
                    </tr>
                  </thead>`
    for(var i = 0; i< dubCustomer.length; i++){
      content += `<tr><td>${i+1}</td> <td>${dubCustomer[i].customerID} </td> <td> ${dubCustomer[i].firstName} ${dubCustomer[i].lastName}</td> <td> <a href="./customers/detail/${dubCustomer[i].customerID}" target="_blank">View</a></td> </tr>`
    }
    content += '</table></div>'
    return content;
  }

  const SaveCus = async () => {
    try {                        
      const response = await SaveIndividual(customer,contact, navigate);      
      if (response && !response.isError) { 
        handleChange('customerID',response?.result?.customerID); 
        handleJobsiteChange('customerID',response?.result?.customerID);
        // if(allContacts.length === 0 && customer.customerType === 'individual'){
        //   handleCreateFirstContact(response?.result?.customerID,customer,0);        
        // }else{
        //   handleCreateFirstContact(response?.result?.customerID,customer,contact);
        // }  
        return response;          
      } else{
        return response;
      }
    } catch (error) {
      console.error('Error saving customer:', error);          
    }
  };

  useEffect(()=>{
    if(isContactSaved){
      fetchContacts(customer?.customerID);
    }
  },[isContactSaved]);

  const handleCreateFirstContact = async (customerID, customer,contact) => {
    let PrimaryContactPayLoad = [];
    if(contact){
       PrimaryContactPayLoad = [{
        "contactID" : 0,
        "customerID": customerID,              
        "firstName": contact?.firstName,
        "lastName":  contact?.lastName,              
        "jobTitle": contact.jobTitle,
        "email": contact?.email,       
        "phoneNumbers": customer?.phoneNumbers,
        "isPrimary": true,
        "status": 'active',
      }]
    }else{
       PrimaryContactPayLoad = [{
        "contactID" : 0,
        "customerID": customerID,              
        "firstName": customer?.firstName,
        "lastName":  customer?.lastName,              
        "jobTitle": 'Manager',
        "email": customer?.email,       
        "phoneNumbers": customer?.phoneNumbers,
        "isPrimary": true,
        "status": 'active',
      }]
    }

    let result = await SaveContact(PrimaryContactPayLoad, navigate);    
    await fetchContacts(customer?.customerID);
    if(result && !result.isError){
      setIsContactSaved(true);
    }
    return result;
  }
  const handleCloseNewCustomerDlg = () => {    
    // if((!isCompleted && !IsSaved) && customer?.customerID){
    const isEqual = _.isEqual(initialCustomerState, customer);
    if (!isEqual) {
      MySwal.fire({
        title: "<strong>Are you sure?</strong>",
        html: "<span>This page has some unsaved changes</span>",
        showCancelButton: true,
        confirmButtonText: "Yes, discard changes!",
        cancelButtonText: "No, stay here",
        width: "420px", // Explicit width control
        padding: "1rem",
        focusConfirm: false,
        showCloseButton: true,
        closeButtonHtml: "&times;", // This is the × symbol
        customClass: {
          popup: "custom-swal-popup",
          title: "custom-swal-title",
          htmlContainer: "custom-swal-html",
          confirmButton: "custom-swal-confirm",
          cancelButton: "custom-swal-cancel",
          closeButton: "custom-swal-close",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          let result = DeleteCustomer(customer.customerID, navigate);
          //console.log(result);
          setOpenNewCustomerDlg(false);
          resetCustomer();
        }
      });
    } else {
      setOpenNewCustomerDlg(false);
      resetCustomer();
    }
      
  };

//   const handleCloseNewCustomerDlg = () => {    
//     setOpenNewCustomerDlg(false);
//     resetCustomer();
// };

  const handleCloseNewContactDlg = () => {
    setOpenNewContactDlg(false);
  }

 // When creating a new customer
const resetCustomer = () => {
  setCustomer(initialCustomerState);
  setActiveStep(0);
  setErrors({});
  setContact(initialContact);
  setBillingFrequencyID(0); // Reset to 0 for new customer
  // Also reset other billing states if needed
  setBillingFreq('select');
  setRecurringType('weekly');
  // ... reset other billing related states
};
  const PhoneResolve = () => {
    for(var i = 0; i< customer?.phoneNumbers?.length; i++){
      handleValidation(i);
    }
  }

  const PhoneResolveContact = () => {
    for(var i = 0; i< contact?.phoneNumbers?.length; i++){
      handleContactValidation(i);
    }
  }

  let isPhoneErrorEmpty = () =>{
    let isAllEmpty = false;
    for(var i = 0; i<Object.keys(phoneError).length; i++){      
        if(Object.values(phoneError)[i] === "") isAllEmpty = true;
        return isAllEmpty;
    }
  }

  let isPhoneErrorEmptyContact = () =>{
    let isAllEmpty = false;
    for(var i = 0; i<Object.keys(contactPhoneError).length; i++){      
        if(Object.values(contactPhoneError)[i] === "") isAllEmpty = true;
        return isAllEmpty;
    }
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleValidation = (index) => {
    if (customer?.phoneNumbers[index]?.phoneNo === '') {
      setIsValidPhone((prev) => ({ ...prev, [index]: false }));
    } else {
      setIsValidPhone((prev) => ({ ...prev, [index]: true }));
    }
  };

  const handleContactValidation = (index) => {
    if (contact?.phoneNumbers[index]?.phoneNo === '') {
      setIsValidContactPhone((prev) => ({ ...prev, [index]: false }));
    } else {
      setIsValidContactPhone((prev) => ({ ...prev, [index]: true }));
    }
  };

  const handleCloseNewJobsiteDlg = async (e) => {   
    const escHandler = (event) => {
      if (event.key === "Escape") {
        if (MySwal.isVisible()) {
          MySwal.close();      
        } else {          
          event.stopPropagation();
          event.preventDefault();
        }
      }
    };
    const isEqual = _.isEqual(initialJobsiteState, jobsite);
    if (jobsiteContent.mode === "create" && !isEqual) {     
      document.addEventListener("keydown", escHandler);
      const result = await MySwal.fire({        
        title: '<strong>Are you sure?</strong>',
        html: '<span>Any unsaved changes will be discarded. Do you want to proceed?</span>',
        showCancelButton: true,
        confirmButtonText: 'Yes, discard changes!',
        cancelButtonText: 'No, stay here',
         width: '420px', // Explicit width control
      padding: '1rem',
        focusConfirm: false,
         showCloseButton: true,
         closeButtonHtml: '&times;', // This is the × symbol
        customClass: {
          popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
        },
        didClose: () => {        
          document.removeEventListener("keydown", escHandler);
        },
      });
      if (result.isConfirmed) {
        await DeleteJobsite(jobsite?.jobsiteID, customer?.customerID, navigate);
        fetchJobsites();
        setOpenNewJobsiteDlg(false); 
      }
    }   
    else if (jobsiteContent.mode === "edit" && !_.isEqual(Oldjobsite, jobsite)) {     
      document.addEventListener("keydown", escHandler);
      MySwal.fire({
        title: "Are you sure?",
        html: "Any unsaved changes will be discarded. Do you want to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#23A26D",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "Cancel",
        allowEscapeKey: true, 
        didClose: () => {        
          document.removeEventListener("keydown", escHandler);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setOpenNewJobsiteDlg(false); 
        }
      });
    }    
    else {
      setOpenNewJobsiteDlg(false);
    }
  };

  const resetJobsite = () =>{
    setJobsite(initialJobsiteState);
  }


  const filteredRows = (isFiltered 
    ? filterData(filteredData, keysToKeep)
    : filterData(data, keysToKeep))
    .sort((a, b) => {
      const nameA = a.customerType === 'Individual' 
        ? (a.Fullname || '').toLowerCase()
        : (a.companyName || '').toLowerCase();
      const nameB = b.customerType === 'Individual' 
        ? (b.Fullname || '').toLowerCase()
        : (b.companyName || '').toLowerCase();
  
      return sortDirection === 'asc'
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    });
  
   

  useEffect(() => {
    if(customer?.customerID> 0)
    fetchContacts(customer?.customerID);
  }, [activeStep]);

  const applyFilters = (filters) => {
  
    const filtered = allCustomers.filter((customer) => {

      const matchesFullName =
        !filters.fullName ||
        (customer.firstName &&
          customer.firstName.trim().toLowerCase().includes(filters.fullName.trim().toLowerCase())) ||
        (customer.lastName &&
          customer.lastName.trim().toLowerCase().includes(filters.fullName.trim().toLowerCase()));

      const matchesCustomerType =
        !filters.customerType || customer.customerType === filters.customerType;

      const matchesEmail =
      !filters.email || (customer.email && customer.email.includes(filters.email));

      const matchesPhoneNumber =
        !filters.phoneNumber ||
        (customer.phoneNumbers &&
          customer.phoneNumbers.some((phone) =>
            phone.phoneNo.includes(filters.phoneNumber)
          ));

        const matchesStatus =
        !filters.status || customer.status === filters.status;
        
        const matchesCompanyName =
        !filters.companyName || customer.companyName === filters.companyName;

        const matchesAddress =
          !filters.address ||
          (customer.companyAddress_Street1 &&
            customer.companyAddress_Street1.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_Street2 &&
            customer.companyAddress_Street2.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_City &&
            customer.companyAddress_City.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_State &&
            customer.companyAddress_State.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_ZipCode &&
            customer.companyAddress_ZipCode.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_County &&
            customer.companyAddress_County.toLowerCase().includes(filters.address.toLowerCase()));

          const matchesBillingAddress =
          !filters.billing_address ||
          (customer.billingAddress_Street1 &&
            customer.billingAddress_Street1.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_Street2 &&
            customer.billingAddress_Street2.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_City &&
            customer.billingAddress_City.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_State &&
            customer.billingAddress_State.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_ZipCode &&
            customer.billingAddress_ZipCode.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_County &&
            customer.billingAddress_County.toLowerCase().includes(filters.billing_address.toLowerCase()));

      const matchesTags =
        !filters.tags.length ||
        (customer.tags &&
          filters.tags.every((tag) => customer.tags.includes(tag)));

      // Combine all conditions
      return (
        matchesFullName &&
        matchesPhoneNumber &&
        matchesEmail &&
        matchesAddress &&
        matchesTags &&
        matchesCustomerType &&
        matchesStatus &&
        matchesCompanyName &&
        matchesBillingAddress
      );
    });

    setFilteredData(filtered);
    setIsFiltered(true);

  };

  const handleReset = () => {
    setFilteredData(allCustomers); // Reset to show all employees
    setIsFiltered(false);
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // console.log("Before unload triggered",isCompleted,customer?.customerID);
      if(!isCompleted && customer?.customerID > 0){
        localStorage.setItem('customerToDelete', customer?.customerID || '');
        e.preventDefault(); 
        e.returnValue = 'Are you sure you want to leave? Unsaved changes might be lost.'; 
      }        
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isCompleted, customer?.customerID]);

  
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 2000000, // 2 MB in bytes
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    onDrop: acceptedFiles => {
      setBtnLoader(true);  
      setTimeout(() => {
        setEmpFiles(acceptedFiles.map(file => Object.assign(file)));
        setBtnLoader(false); 
      }, 1000);  // Simulating a delay for loading effect
    },
    onDropRejected: () => {
      toast.error('You can only upload 1 file with a maximum size of 2 MB.', {
       duration: 2000
      });
      //setMessage('You can only upload 1 file with a maximum size of 2 MB.');
      setBtnLoader(false);
    }
  });

  const calculateContentWidth = (rows, field) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = "15px Lexend"; // Match the font used in your grid
  
    let maxWidth = 130; // Minimum width
    rows.forEach((row) => {
      const textWidth = context.measureText(row[field]).width;
      maxWidth = Math.max(maxWidth, textWidth + 16); // Add some padding
    });
  
    return maxWidth;
  };

  const handleOpenTagManagementDlg = () => {
    setOpenTagManagementDlg(true);
  }

  const columns = [
    {
      flex: 0.1,
      field: "id",
      hide: true,
      minWidth: 50,
      headerName: "ID",
      renderCell: ({ row }) => {
        const { id } = row;

        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%",
              cursor:'pointer', 
              '&:hover' : {
                textDecoration:'underline'
              },
             }} 
            onClick={() => navigate(`/customers/detail/${id}`)}
          >
            <Typography sx={{ flexGrow: 1 }}>{id}</Typography>
          </Box>
        );
      },
    },
    {
      field: "Fullname",
      headerName: "Name",
      sortable: false, 
      minWidth: calculateContentWidth(data, 'Fullname'),
      renderHeader: () => (
        <Box
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={toggleSortDirection} 
        >
          <Typography sx={{ mr: 1 }}>Name</Typography>
          <Icon icon={sortDirection === 'asc' ? 'tabler:chevron-up' : 'tabler:chevron-down'} />
        </Box>
      ),
      renderCell: ({ row }) => {
        const { Fullname, id, companyName, customerType } = row;
    
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              cursor: "pointer",
              '&:hover': { textDecoration: 'underline' },
            }}
            onClick={() => navigate(`/customers/detail/${id}`)}
          >
            <Typography>{customerType === 'Individual' ? Fullname : companyName}</Typography>
          </Box>
        );
      }
    },
    
    {
      flex: 0.1,
      field: "customerType",
      minWidth: 120,
      editable: true,
      headerName: "Type",
      renderCell: ({ row }) => {
        const { customerType } = row;
        return (
          <>
            <CustomChip
              rounded
              size="small"
              skin="dark"
              sx={{ lineHeight: 1, cursor: 'pointer',
                '&:hover' : {
                  transform: 'scale(1.05, 1.05)'
                }
               }}
              color={customerType === "Individual" ? "warning" : "info"} //'success' // Use color names: primary, secondary, error, warning, info, success
              label={customerType}
            />
          </>
        );
      },
    },
    {
      flex: 0.1,
      field: "isLead",
      minWidth: 85,
      editable: true,
      headerName: "Lead",
      renderCell: ({ row }) => {
        const { isLead } = row;
        return (
          <>
            { isLead === "Lead" ? (
            <CustomChip
                rounded
                size="small"
                skin="light"
                sx={{ lineHeight: 1, cursor: 'pointer',
                  '&:hover' : {
                    transform: 'scale(1.05, 1.05)'
                  }
                  }}
                color={"success"}
                label={isLead}
              />
          ) : (
            <Typography sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>-</Typography>
          ) }
         </>
        )
      },
    },
    {
      flex: 0.1,
      field: "companyAddress_Street1",
      minWidth: 120,
      headerName: "Address",
      renderCell: ({ row }) => {
        const { companyAddress_Street1 } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%",
            '&:hover' : {
                  transform: 'scale(1.05, 1.05)'
                }
           }}>
            <Typography sx={{ flexGrow: 1 }}>
              {companyAddress_Street1}
            </Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "createDate",
      minWidth: 140,
      headerName: "Created On",
      renderCell: ({ row }) => {
        const { createDate } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{createDate}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "createdBy",
      minWidth: 120,
      headerName: "Created By",
      renderCell: ({ row }) => {
        const { createdBy } = row;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{createdBy}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "lastService",
      hide: true,
      minWidth: 120,
      headerName: "Last Service",
      renderCell: ({ row }) => {
        const { lastService } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{lastService}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "lastActivity",
      hide: true,
      minWidth: 120,
      headerName: "Last Activity",
      renderCell: ({ row }) => {
        const { lastActivity } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{lastActivity}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "referredBy",
      minWidth: 120,
      headerName: "Referred By",
      renderCell: ({ row }) => {
        const { referredBy } = row;

        const referrer = allCustomers.find((c) => c.customerID === referredBy)

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%",
            '&:hover' : {
                  transform: 'scale(1.05, 1.05)'
                }
           }}>
            <Typography sx={{ flexGrow: 1 }}>{
              referrer.firstName || referrer.lastName ? 
              `${referrer?.firstName} ${referrer?.lastName}` :
              referrer.companyName ?
              `${referrer?.companyName}` :
              ''
            }
            </Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "isActive",
      minWidth: 95,
      headerName: "Status",
      renderCell: ({ row }) => {
        const { isActive } = row;

        return (
          <CustomChip
            rounded
            size="small"
            skin="light"
            sx={{ lineHeight: 1, cursor: 'pointer',
              '&:hover' : {
                  transform: 'scale(1.05, 1.05)'
                }
             }}
            color={isActive === "Active" ? "success" : "secondary"} //'success' // Use color names: primary, secondary, error, warning, info, success
            label={isActive}
          />
        );
      },
    },
    {
      flex: 0.1,
      field: "tags",
      // minWidth: 280,
      minWidth: calculateContentWidth(data, 'tags'),
      headerName: "Tags",
      renderCell: ({ row }) => {
        const { tags } = row;

        return (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "nowrap",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CustomChip
              rounded
              label="Add"
              size="small"
              color="info"
              skin="light"
              sx={{ lineHeight: 1 }}
              onDelete={() => console.log("Add Tag")}
              deleteIcon={<Icon icon="tabler:circle-plus" />}
            />

            {tags && tags.length > 0 ? (
              tags.length <= 2 ? (
                tags.map((tag, index) => (
                  <CustomChip
                    key={index}
                    rounded
                    label={tag.tagName}
                    size="small"
                    color="info"
                    skin="light"
                    sx={{ lineHeight: 1 }}
                    onDelete={() => console.log("tag deleted")}
                  />
                ))
              ) : (
                <>
                  <CustomChip
                    rounded
                    label={tags[0].tagName}
                    size="small"
                    color="info"
                    skin="light"
                    sx={{ lineHeight: 1 }}
                    onDelete={() => console.log("First tag deleted")}
                  />
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ display: "inline-flex", alignItems: "center" }}
                  >
                    ...
                  </Typography>
                  <CustomChip
                    rounded
                    label="See More"
                    size="small"
                    color="info"
                    skin="light"
                    sx={{ 
                      lineHeight: 1,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 58, 112, 0.16)',
                      },  
                    }}
                    onClick={() => setOpenTagManagementDlg(true)}
                  />
                </>
              )
            ) : (
              <Typography variant="body2" color="textSecondary">
                No tags
              </Typography>
            )}
          </Box>
        );
      },
    },
  ];

  const handleFilterTypeChange = (buttonIndex,type) => {
    setFilterType(type);  
    setSelectedButton(buttonIndex);        
    setPaginationModel((prevModel) => ({
        ...prevModel,
        page: 0,
      }));
  };
  
  const getCustomerById = (id) => {      
    const cus = allCustomers.find(cus => cus.customerID === id);    
    return cus ? cus : null;
  };

  const handleCloseTagManagementDlg = () => {
    setOpenTagManagementDlg(false);
  }

  const handlePaginationModel = (model) =>{
    if(model.pageSize === -1){
      setPaginationModel({
        page: 0,
        pageSize: -1,
      })
    }else{
      setPaginationModel(model);
    }  
  }

  const handleClearSearch = () => {
    handleSearchChange("");
  };

  const getContactById = (id) =>{
    return allContacts.filter( x => x.contactID === id)
  }

  // const getDubContent = (dubCustomer) =>{   
  //   let content = `One or more customers named "${customer?.firstName} ${customer?.lastName}" already exist:</br>`;
  //   content +='<div style="overflow-y:auto; max-height:400px">';
  //   for(var i = 0; i< dubCustomer.length; i++){
  //     content += `<p style="display:flex; justify-content: space-between;font-size: medium; "><span> ${i+1}.</span> <span>CustomerID : ${dubCustomer[i].customerID} </span> <span> Name : ${dubCustomer[i].firstName} ${dubCustomer[i].lastName} </span> <a href="./customers/detail/${dubCustomer[i].customerID}" target="_blank">View</a></p>`
  //   }
  //   content += '</div>'
  //   return content;
  // }

  const showBulkConfirmation = (count, message, type,BulkData, btnText) => {
    const confirmButtonText = type === 'Delete' 
    ? 'Yes, delete it' 
    : 'Yes, apply changes';
    MySwal.fire({
      title: `Are you sure?`,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#23A26D',
      cancelButtonColor: '#d33',
      confirmButtonText: btnText,
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        if(type === 'Delete'){
          handleBulkDelete(); 
        }else if(type === 'Operation'){
          handleBulkSave(BulkData);
        }
              
      }
    });
  };

  const handleGridSelection = (selectedRows) => {
    setSelectedRows(selectedRows);
  };

  const handleBulkCusTypeChange = (value) =>{
    setBulkCusType(value);
  }
  
  const handleBulkCusStatusChange = (value) =>{
    setBulkCusStatus(value);
  }

  const handleBulkCusLeadChange = (value) =>{
    setBulkCusLead(value);
  }

  const handleBulkOperations = async () =>{   
    let BulkData = [];
    let count = Object.values(selectedRows).length;
    if(count > 0 && (bulkCusType || bulkCusStatus || bulkCusLead)){
        for(var i = 0; i< Object.values(selectedRows).length; i++){
          BulkData.push(
            {
              "CustomerID" : Object.values(selectedRows)[i],
              "customerType" : bulkCusType || null,
              "isActive" : bulkCusStatus? bulkCusStatus === 'Active' : null,
              "isLead": bulkCusLead === "yes" ? true : (bulkCusLead === "no" ? false : null),
            }
          )
        }
        showBulkConfirmation(count,`Do you want to make changes on ${count} ${count === 1? 'Customer' : 'Customers'}?`,'Operation',BulkData, 'Yes, do it');
        
        return;
    }else if (!bulkCusType){
      toast.error(`Failed! Please select customer type before proceeding.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
    } else if (!bulkCusLead){
      toast.error(`Failed! Please select is customer lead before proceeding.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
    }
    else if (!bulkCusStatus){
      toast.error(`Failed! Please select status before proceeding.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
    }    
  }

  const handleBulkSave = async (BulkData) =>{
    try {   
      NProgress.start();               
      const result = await SaveBulkCustomer(BulkData);
      if (result && !result.isError) {
        await fetchData()                           
        toast.success(`Updated! Customer Information updated successfully.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          }); 
          handleClearSelection();          
      } else {
        toast.error(`Failed! ${result.result[0].failureReason}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });     
          handleClearSelection();       
        console.error('Error saving customer:', result.message);        
      }
    } catch (error) {
      handleClearSelection();
      console.error('Error saving customer:', error);          
    }finally {
      NProgress.done(); 
    }
  }

  const handleBulkDelete = async () => {
    let BulkData = [];
    if(Object.values(selectedRows).length > 0){
      for(var i = 0; i< Object.values(selectedRows).length; i++){
        let CusID = Object.values(selectedRows)[i];
        let Cus =  getCustomerById(Object.values(selectedRows)[i]);
        handleDeleteCustomer(CusID,Cus.customerType.toLowerCase() === 'indiviual'? Cus.firstName+' '+Cus.lastName: Cus.companyName);
      }
    }  
  }

  const handleClearSelection = () => {
    setRowSelectionModel([]);
    setSelectedRows(0);
    setBulkCusStatus(0);
    setBulkCusLead(0);
    setBulkCusType(0);
  };

  const handleDeleteCustomer = async (cusID, Name) =>{  
    NProgress.start();  
      try {
        const result = await DeleteCustomer(cusID,navigate);
        if (result && result.form) {
          console.error(result.form);
          // console.log(result.form);
        } else {
         await fetchData(); 
          // console.log('Customer deleted successfully!'); 
          toast.success(`Customer "${Name || 'Data'}" has been successfully deleted.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });                 
        }
      } catch (error) {
        console.error('Error deleting customer:', error);      
      }finally {
        NProgress.done(); 
    }
  }

  const handleOpenBulkImportCustomerDlg = () => {
    setBulkImportContent({title:'Customers', ImportURL:'/customers/add-bulk-customers', customerID: 0})
    setOpenBulkImportDlg(true);   
  };
  const handleOpenBulkImportContactDlg = () => {
    setBulkImportContent({title:'Contacts', ImportURL: '/customers/add-bulk-contacts', customerID: customer.customerID})
    setOpenBulkImportDlg(true);   
  };
  const handleOpenBulkImportJobsiteDlg = () => {
    setBulkImportContent({title:'Jobsites', ImportURL : '/customers/add-bulk-jobsites', customerID: customer.customerID})
    setOpenBulkImportDlg(true);   
  };

  const handleCloseBulkImportDlg = () => {
    setOpenBulkImportDlg(false);
  };

  const handleCSVExport = () => {
    if(exportToCSV(allCustomers, `Customers [${getCurrentDate()}].csv`, { delimiter: ',', includeHeaders: true })){
      Swal.fire(
            {
              title: 'Exported!',
              text: 'Data has been successfully exported!',
              icon: 'success',
              confirmButtonColor: '#23a26d', 
            });
    }else{
      Swal.fire(
        {
          title: 'Failed!',
          text: 'No data available to export!',
          icon: 'error',
          confirmButtonColor: '#23a26d', 
        });
    }
    
  };

  const handleExcelExport = () =>{
    if(ExportToExcel(allCustomers, `Customers [${getCurrentDate()}]`)){
      Swal.fire(
        {
          title: 'Exported!',
          text: 'Data has been successfully exported!',
          icon: 'success',
          confirmButtonColor: '#23a26d', 
        });
      }else{
        Swal.fire(
          {
            title: 'Failed!',
            text: 'No data available to export!',
            icon: 'error',
            confirmButtonColor: '#23a26d', 
          });
      }
  }

  const buttons = [
    { name: "All", searchKeyWord: "" },
    { name: "Customers", searchKeyWord: "NL" },
    { name: "Leads", searchKeyWord: "Lead" },
  ];

  const NoRowsOverlay = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          padding: 2,
        }}
      >
        <Typography variant="h6" color="secondary">
          Oops! No Data Found
        </Typography>
      </Box>
    );
  };

  //#endregion end of handlers and methods

  // function buildBillingPayload(customerID, billingFrequencyID) {
  //   const payload = {
  //     billingFrequencyID,
  //     customerID,
  //     frequencyType: billingFreq,
  //     billingFrequency: billingFreq === "recurring" ? recurringType : billingFreq,
      
  //   };
  
  //   if (billingFreq === "Per Job") {
  //     // console.log(payload)
  //     return payload;
  //   }
  
  //   // recurring
  //   payload.recurringType = recurringType;
  
  //   const dayMap = {
  //     mon: "Monday",
  //     tue: "Tuesday",
  //     wed: "Wednesday",
  //     thurs: "Thursday",
  //     fri: "Friday",
  //   };
  
  //   if (recurringType === "weekly") {
  //     payload.intervalDays = 7;
  //     if (formatsBilling) {
  //       payload.days = [{ dayName: dayMap[formatsBilling] || formatsBilling }];
  //       payload.cycleStartDate = null;
  //     } else {
  //       payload.cycleStartDate = null;
  //       payload.days = [];
  //     }
  //   } else if (recurringType === "bi-weekly") {
  //     // if (!cycleStartDate) {
  //     //   throw new Error("First Occurrence Date is required for bi-weekly recurring billing.");
  //     // }
  //     payload.intervalDays = 14;
  //     payload.cycleStartDate = cycleStartDate?.toISOString() || null;
  
  //     if (formatsBilling) {
  //       payload.days = [{ dayName: dayMap[formatsBilling] || formatsBilling }];
  //     } else {
  //       payload.days = [];
  //     }
  //   } else if (recurringType === "monthly") {
  //     payload.days = [];
  //     payload.cycleStartDate = null;
  //   }
  //   // console.log(payload)
  //   return payload;
  // }  

  function buildBillingPayload(customerID, billingFrequencyID) {
    const payload = {
      billingFrequencyID,
      customerID,
      frequencyType: billingFreq,
      billingFrequency: billingFreq === "recurring" ? recurringType : billingFreq,
    };
  
    // If it’s one-off, nothing else to do
    if (billingFreq === "Per Job") {
      return payload;
    }
  
    // helper: map names to JS day-of-week (0=Sunday … 6=Saturday)
    const weekdayIndex = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };
  
    // helper: next weekday strictly _after_ given date
    function getNextWeekday(dayName, fromDate = new Date()) {
      const target = weekdayIndex[dayName];
      const today = fromDate.getDay();
      // “|| 7” makes sure if today===target you get 7 days ahead, not zero
      const delta = ((target - today + 7) % 7) || 7;
      const d = new Date(fromDate);
      d.setDate(d.getDate() + delta);
      return d;
    }
  
    // start filling recurring fields
    payload.recurringType = recurringType;
    const dayMap = { mon: "Monday", tue: "Tuesday", wed: "Wednesday", thurs: "Thursday", fri: "Friday" };
    const dayName = formatsBilling ? (dayMap[formatsBilling] || formatsBilling) : null;
  
    if (recurringType === "weekly") {
      payload.intervalDays = 7;
      payload.cycleStartDate = null;
      payload.days = dayName ? [ { dayName } ] : [];
  
      // compute nextRunDate
      if (dayName) {
        payload.nextRunDate = getNextWeekday(dayName).toISOString();
      }
  
    } else if (recurringType === "bi-weekly") {
      payload.intervalDays   = 14;
      payload.cycleStartDate = cycleStartDate?.toISOString() || null;
      payload.days           = dayName ? [{ dayName }] : [];
    
      if (cycleStartDate) {
        // 1) two weeks after your very first-occurrence date
        const base = new Date(cycleStartDate);
        base.setDate(base.getDate() + 14);
        // 2) then bump forward to the next matching weekday
        payload.nextRunDate = getNextWeekday(dayName, base).toISOString();
      } 
      else if (dayName) {
        // 1) find the next upcoming matching weekday from today
        const first = getNextWeekday(dayName);
        // 2) then jump ahead two weeks (it’ll land on the same weekday)
        const twoWeeksLater = new Date(first);
        twoWeeksLater.setDate(twoWeeksLater.getDate() + 14);
        payload.nextRunDate = twoWeeksLater.toISOString();
      }
    } else if (recurringType === "monthly") {
      payload.days = [];
      payload.cycleStartDate = null;
  
      // 1st of next calendar month
      const today = new Date();
      const nextMonthFirst = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      payload.nextRunDate = nextMonthFirst.toISOString();
    }
  
    // console.log(payload)
    return payload;
  }
  

  const validateBilling = () => {
    if (billingFreq === "recurring") {
      if (recurringType === "weekly" && !formatsBilling) {
        throw new Error("Select a day for weekly recurring billing.");
      }
      if (recurringType === "bi-weekly") {
        // if (!cycleStartDate) throw new Error("First Occurrence Date is required for bi-weekly.");
        if (!formatsBilling) throw new Error("Select a day for bi-weekly recurring billing.");
      }
    }
  };
  
 const handleSaveBillingInfo = async (customerID, billingFrequencyID) => {
  try {
    validateBilling();
    const billingObject = buildBillingPayload(customerID, billingFrequencyID);
    const result = await SaveBillingInfo(billingObject);
    
    if (result && !result.isError) {
      // Store the billingFrequencyID from the response for future updates
      if (result.result?.billingFrequencyID) {
        setBillingFrequencyID(result.result.billingFrequencyID);
      }
      return result;
    } else if (result?.isError && result?.message?.includes("already exists")) {
      // If billing info already exists, try to fetch the existing ID and update
      const existingBilling = await GetBillingInfo(customerID);
      if (existingBilling && !existingBilling.isError && existingBilling.result) {
        // Use the existing billingFrequencyID to update
        const updatedBillingObject = buildBillingPayload(
          customerID, 
          existingBilling.result.billingFrequencyID
        );
        const updateResult = await SaveBillingInfo(updatedBillingObject);
        
        if (updateResult && !updateResult.isError) {
          setBillingFrequencyID(existingBilling.result.billingFrequencyID);
          return updateResult;
        }
      }
      throw new Error("Failed to update existing billing info");
    }
    
    toast.error(result?.message || "Error Saving Billing Info. Please try again later!", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
  } catch (err) {
    toast.error(err.message || "Invalid billing configuration.", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
    throw err;
  }
};

  const CustomerProps = {
    NProgress,
    StepJobsite,
    tagManagementData,
    columnsAddContact,
    quickViewOpen,
    contacts : allContacts,
    jobsite,
    propertyAreaList,
    alertList,
    customer,
    errors, 
    isValidPhone, 
    isValidContactPhone,
    phoneError,  
    contactPhoneError,
    theme,
    searchContactText,
    searchJobsiteText,
    filteredContactRows,
    paginationModelAddContact,
    allJobsites,
    keysToKeep,
    //openNewCustomerDlg,
    openNewContactDlg,
    openUpdateContactDlg,
    toast,
    contactID,
    allCustomers,
    data,
    loading,
    openNewJobsiteDlg,
    allContacts,
    propertyArea,
    areaMeasurement,
    activeStepJobsite,
    jobsiteContent,
    columns,    
    contentHeightFixed,
    buttons,
    selectedButton,
    paginationText,
    searchText,
    bulkCusType,  
    bulkCusStatus, 
    bulkCusLead,  
    selectedRows,
    paginationModel,
    rowSelectionModel,
    openBulkImportDlg,
    EmpFiles,
    btnLoader,
    openTagManagementDlg,
    bulkTags,    
    filteredRows,
    getRootProps,
    getInputProps,
    setBulkTags,
    setEmpFiles,  
    setRowSelectionModel,
    setBulkCusStatus,
    setBulkCusType,
    handleSearchChange,
    setOpenNewJobsiteDlg,
    clearPropertyArea,
    fetchPropertyArea,
    clearAreaMeasurement,
    setActiveStepJobsite,
    setPropertyArea,
    setAreaMeasurement,
    setBulkCusLead,
    navigate,
    handleOpenNewJobsiteDlg,
    setContactID,
    handleChange,
    setAlertList,
    handleQuickViewClose,
    handleJobsiteChange,
    handleJobsiteDelete,
    handleJobsiteEdit,
    handleQuickViewOpen,
    fetchAlerts,
    handlePhoneFieldChange,
    handleSetPrimary,
    handleDeletePhoneField,
    handleAddPhoneField,
    handleClearContactSearch,
    handleContactSearchChange,
    handleClearJobsiteSearch,
    handleJobsiteSearchChange,
    handleOpenNewContactDlg,
    handleContactPaginationModel,
    handleOpenNewJobsiteDlg,
    handleNext,
    handleBack,
    handleClose:handleCloseNewCustomerDlg,
    handleCloseNewCustomerDlg,
    handleOpenNewCustomerDlg,
    handleCloseNewContactDlg,
    handleCloseUpdateDlg,
    handleEditContactClick,
    setLoading,
    fetchContacts,   
    fetchJobsites,
    handleCloseNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    NoRowsOverlay,        
    handleCloseBulkImportDlg,
    handleOpenBulkImportCustomerDlg,
    handleOpenBulkImportContactDlg,
    handleOpenBulkImportJobsiteDlg,
    handleDeleteCustomer,
    handleClearSelection,
    handleBulkDelete,
    handleBulkSave,
    handleBulkOperations,
    handleBulkCusLeadChange,
    handleBulkCusStatusChange,
    handleBulkCusTypeChange,
    handleGridSelection,
    showBulkConfirmation,
    getContactById,
    handleClearSearch,
    handlePaginationModel,
    handleCloseTagManagementDlg,
    getCustomerById,
    handleFilterTypeChange,
    handleOpenTagManagementDlg,
    calculateContentWidth,
    handleReset,
    applyFilters,
    files,
    setFiles,
    setAllJobsites,  
    BulkImportContent,
    setBulkImportContent,
    RootProps : getRootProps ,
    InputProps : getInputProps,
    contact, 
    handleContactChange,
    errorContacts,
    handleContactPhoneFieldChange,
    handleSetPrimaryContact,
    handleDeletePhoneFieldContact,
    handleAddPhoneFieldContact,
    setCustomer,
    setJobsite,
    isCompleted,
    setIsCompleted,
    resetJobsite,
    setOpenTagManagementDlg,
    filteredData,
    resetCustomer,
    // Billing Info
    // estTravelTime, 
    // setEstTravelTime,
    billingFreq, 
    setBillingFreq,
    recurringType, 
    setRecurringType,
    depositReq, 
    setDepositReq,
    depositType, 
    setDepositType,
    formatsBilling, 
    setFormatsBilling,
    monthlyOptions, 
    setMonthlyOptions,
    // occurrences, 
    // setOccurrences,
    cycleStartDate, 
    setCycleStartDate,
    intervalDaysInput, 
    setIntervalDaysInput,
    weekOfMonth, 
    setWeekOfMonth,
    quarter, 
    setQuarter,
    monthOfQuarter, 
    setMonthOfQuarter,
    // handleEstTravelTimeChange,
    handleBillingFreqChange,
    handleRecurringTypeChange,
    handledDepositReqChange,
    handleDepositTypeChange,
    handleFormatBilling,
    formatsBillingWeekly,
    handleSaveBillingInfo,
    GetBillingInfo,
    allEmployees,
    handleExcelExport,
    handleCSVExport,
    handleDeleteContact,
    isDeleting
  }

  return {    
    CustomerProps
  };
}
